// The instant the old site closes.
//
// Stored as an absolute UTC instant rather than a wall-clock date on purpose.
// Date.now() counts milliseconds from the epoch measured in UTC on every
// machine, so subtracting from this constant yields the same remaining time for
// every visitor no matter their timezone — each just sees it hit zero at their
// own local clock reading. Parsing a bare '2026-08-01' or an offset-less
// datetime would instead resolve against local time and silently drift the
// deadline per user, so the trailing Z is load-bearing.
export const CLOSING_AT = Date.parse('2026-08-01T00:00:00Z');

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

// Remaining time until CLOSING_AT, clamped at zero so a visit after the
// deadline reports expired rather than counting upward.
export function getTimeRemaining(now = Date.now()) {
	const ms = Math.max(0, CLOSING_AT - now);

	return {
		expired: ms === 0,
		days: Math.floor(ms / DAY),
		hours: Math.floor(ms / HOUR) % 24,
		minutes: Math.floor(ms / MINUTE) % 60,
		seconds: Math.floor(ms / SECOND) % 60
	};
}

// Whether the deadline has passed. Kept next to CLOSING_AT so the countdown and
// the shutdown page can never disagree about when the site closed.
export function isSiteClosed(now = Date.now()) {
	return now >= CLOSING_AT;
}

export function padCountdownUnit(value) {
	return String(value).padStart(2, '0');
}
